import React, { useEffect, useState } from "react";
import { Card, Row, Col, Typography, Statistic } from "antd";
import CountUp from "react-countup";
import axios from "axios";

import "./Styles/Dashboard.css";

const { Title, Text } = Typography;

const Dashboard = () => {
  const [totalOrders, setTotalOrders] = useState(0);
  const [TodaytotalOrders, setTodayTotalOrders] = useState(0);
  const [totalRefundOrders, setTotalRefundOrders] = useState(0);
  const [todayRefundOrders, setTodayRefundOrders] = useState(0);
  const [completedOrders, setCompletedOrders] = useState(0);
  const [TodaycompletedOrders, setTodayCompletedOrders] = useState(0);

  useEffect(() => {
    const vendorId = localStorage.getItem("vendor_id");

    console.log(vendorId);

    // Function to fetch data from API
    const fetchData = async () => {
      try {
        let data = {
          vendor_id: vendorId,
        };
        const response = await axios.post(
          //"https://app-nm5xb3nmya-uc.a.run.app/api/order_stats"
          "https://app-tl2d3sc25q-uc.a.run.app/api/order_counts",
          data
        );
        console.log("Response data:", response.data);
        setTotalOrders(response.data.total_processing_orders);
        setTotalRefundOrders(response.data.total_refund_orders);
        setTodayRefundOrders(response.data.today_refund_orders);
        setCompletedOrders(response.data.total_completed_orders);
        setTodayTotalOrders(response.data.total_today_orders);

        setTodayCompletedOrders(response.data.today_completed_orders);
      } catch (error) {
        console.error("Error fetching data:", error.message); // Log the error message
        console.error("Error details:", error); // Log the full error object for more information
      }
    };
    if (vendorId) {
      fetchData(); // Call the fetch function when component mounts
    }
  }, []);

  const renderStatistic = (title, value, todayValue) => (
    <Card className="dashboard-card">
      <Title level={4}>{title}</Title>
      <Statistic
        valueStyle={{ fontSize: "32px" }}
        valueRender={() => <CountUp end={value} duration={2} />}
      />
      <Text type="success">Today: {todayValue}</Text>
    </Card>
  );

  return (
    <div className="dashboard-container">
      <Title level={2} className="dashboard-title">
        Dashboard Statistics
      </Title>
      <Row gutter={[16, 16]} className="dashboard-row">
        <Col xs={24} sm={12} md={6}>
          {renderStatistic("New Orders", totalOrders, TodaytotalOrders)}
        </Col>
        <Col xs={24} sm={12} md={6}>
          {renderStatistic(
            "Completed Orders",
            completedOrders,
            TodaycompletedOrders
          )}
        </Col>
        <Col xs={24} sm={12} md={6}>
          {renderStatistic(
            "Return Orders",
            totalRefundOrders,
            todayRefundOrders
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
